import { Color } from 'three';

/** Colors of different event data types. */
export const EVENT_DATA_TYPE_COLORS = {
  Hits: new Color(0xff0000),
  Tracks: new Color(0xff0000),
  Jets: new Color(0x2194ce),
  CaloClusters: new Color(0xffd166),
  MuonChambers: new Color(0xff0000),
  Vertices: new Color(0xffd166),
  MissingEnergy: new Color(0xffffff),
  PlanarCaloCells: new Color(0xfff69a),
};
